import  { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router";
import UploadUtilityBill from "./UploadUtilityBill";
import UploadCacDocument from "./UploadCacDocument";

const KYCLevelTwoDetails = ({
  onBack,
  data,
  reload,
  setReload,
  setShowLevelFourDetails,
  setShowLevelThreeDetails,
}) => {
  const [step, setStep] = useState("requirements");
  const navigate = useNavigate();
  const { onboardingProgress, onboardingStatus } = data;
  const { pendingItems } = onboardingProgress;
  // Filter out completed items - only show Open or Pending items
  const activePendingItems = useMemo(
    () => pendingItems?.filter((item) => item.status !== "Completed") || [],
    [pendingItems]
  );

  const proceedToNextStep = (requirement) => {
    if (requirement && requirement.item) {
      setStep(requirement.item); // Set the step dynamically based on the requirement
    }
  };

  useEffect(() => {
    if (onboardingStatus !== "Level 3") {
      onBack(); // This will reset the detail views
      setShowLevelThreeDetails(false); // Close Level Two
      setShowLevelFourDetails(true); // Show Level Three
    } else if (activePendingItems.length === 0) {
      // Only navigate if all items are completed (no active pending items)
      onBack(); // This will reset the detail views
      setShowLevelThreeDetails(false); // Close Level Two
      setShowLevelFourDetails(true); // Show Level Three
    }
  }, [activePendingItems, onBack, setShowLevelThreeDetails, setShowLevelFourDetails, onboardingStatus]);

  console.log("activePendingItems", activePendingItems[0])

  if (step === "upload_utilitybill") {
    return (
      <UploadUtilityBill
        onBack={() => setStep("requirements")}
        title="Upload Utility Bill"
        stepNumber="01"
        refresh={reload}
        setRefresh={setReload}
      />
    );
  }

  if (step === "cacdocument") {
    return (
      <UploadCacDocument
        onBack={() => setStep("requirements")}
        title="Upload CAC Document"
        stepNumber="02"
        refresh={reload}
        setRefresh={setReload}
      />
    );
  }

  return (
    <div className="w-full md:w-[650px] mx-auto p-4">
      <button
        onClick={onBack}
        className="text-blue-600 text-sm mb-4 flex items-center gap-2"
      >
        <span>←</span> Back
      </button>

      <h3 className="text-xl font-semibold text-gray-800 mb-4">
        Level Three KYC Details
      </h3>

      <div className="bg-primary-color text-white text-lg rounded-lg px-6 py-4 flex justify-between items-center my-[50px]">
        <span>Verification Requirements</span>
        {activePendingItems.length > 0 && (
        <button
            onClick={() => proceedToNextStep(activePendingItems[0])}
          className="bg-white text-primary-color font-semibold px-8 py-4 rounded-md hover:bg-gray-50 transition-colors"
        >
          Proceed
        </button>
        )}
      </div>

      <div className="border border-gray-300 rounded-b-lg">
        {/* <div
          className={`flex items-center px-4 py-8 border-b border-gray-200 ${
            step === "upload_utilitybill" ? "bg-gray-50" : ""
          }`}
        >
          <div className="w-6 h-6 flex items-center justify-center rounded-full border-2 border-deeper-blue mr-4">
            <div className="w-3 h-3 rounded-full bg-deeper-blue"></div>
          </div>
          <span className="text-gray-700">Upload Utility Bill</span>
        </div>

        <div
          className={`flex items-center px-4 py-8 border-b border-gray-200 ${
            step === "cacdocument" ? "bg-gray-50" : ""
          }`}
        >
          <div className="w-6 h-6 flex items-center justify-center rounded-full border-2 border-deeper-blue mr-4">
            <div className="w-3 h-3 rounded-full bg-deeper-blue"></div>
          </div>
          <span className="text-gray-700"> CAC Number</span>
        </div> */}

        {activePendingItems?.map((requirement, index) => (
          <div
            key={index}
            className={`flex items-center px-4 py-8 border-b border-gray-200 ${
              step === requirement.item ? "bg-gray-50" : ""
            }`}
          >
            <div className="w-6 h-6 flex items-center justify-center rounded-full border-2 border-deeper-blue mr-4">
              <div className="w-3 h-3 rounded-full bg-deeper-blue"></div>
            </div>
            <span className="text-gray-700 capitalize">
              {requirement.item.replace("_", " ")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KYCLevelTwoDetails;
